import { Injectable } from '@angular/core';
import { TokenService } from 'src/app/shared/service/token.service';

@Injectable({ providedIn: 'root' })
export class TopSellingService {
  constructor(private tokenService: TokenService) {}
  public generateUserKeyLocals(): string {
    var keyUserLocals =
      this.tokenService.getTenant() +
      ':' +
      this.tokenService.getEmail() +
      ':' +
      this.tokenService.getUsername();

    return btoa(keyUserLocals);
  }

  public onLoadLocalsStore(): any {
    var id= localStorage.getItem(this.generateUserKeyLocals()) ?? '';

    if (id === '') return '';
    else return id;
  }

  public onSaveLocalsStore(id: any): void {
    const userKeyLocals = this.generateUserKeyLocals();

    localStorage.removeItem(userKeyLocals);

    localStorage.setItem(userKeyLocals, id);
  }
}
